<template>
    <router-link v-if="route.name !== 'maia'"
                 class="maia-launcher"
                 :to="{name: 'maia'}"
                 aria-label="Open MaiA, the Mergerfilers AI assistant"
                 title="Ask MaiA">
        <span class="material-symbols-outlined" aria-hidden="true">chat_bubble</span>
    </router-link>
</template>

<script setup lang="ts">
import {useRoute} from "vue-router";

const route = useRoute();
</script>

<style scoped lang="scss">
.maia-launcher {
    display: grid;
    position: fixed;
    right: calc(24px + env(safe-area-inset-right));
    bottom: calc(24px + env(safe-area-inset-bottom));
    z-index: 100;
    place-items: center;
    width: 58px;
    height: 58px;
    border-radius: 50%;
    background: #d07a2d;
    box-shadow: 0 8px 22px rgba(17, 43, 60, 0.24);
    color: #ffffff;
    text-decoration: none;
    transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;

    &:hover {
        background: #a96022;
        box-shadow: 0 11px 26px rgba(17, 43, 60, 0.3);
        transform: translateY(-2px);
    }

    &:focus-visible {
        outline: 3px solid #112b3c;
        outline-offset: 3px;
    }

    span {
        font-size: 28px;
    }

    .material-symbols-outlined {
      font-variation-settings:
          'FILL' 0,
          'wght' 700,
          'GRAD' 200,
          'opsz' 24
    }
    @media (max-width: $max-sm-screen) {
        right: calc(16px + env(safe-area-inset-right));
        bottom: calc(16px + env(safe-area-inset-bottom));
        width: 52px;
        height: 52px;
    }
}
</style>
